import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;

      // Global navigation shortcuts (Alt + key)
      if (e.altKey) {
        switch (e.key) {
          case 'h':
            e.preventDefault();
            navigate('/');
            break;
          case 'p':
            e.preventDefault();
            navigate('/profile');
            break;
          case 'l':
            e.preventDefault();
            navigate('/leaderboard');
            break;
          case 's':
            e.preventDefault();
            navigate('/settings');
            break;
        }
        return;
      }

      // Escape to go back
      if (e.key === 'Escape') {
        const path = location.pathname;
        if (path.startsWith('/game/')) {
          // Don't navigate away from game on Escape — too destructive
          return;
        }
        if (path !== '/') {
          e.preventDefault();
          navigate(-1);
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate, location.pathname]);
}
